// Turbo 8 fetches a link's page on hover. These pages change the session or
// data just by loading (sign-up/sign-in reset onboarding state and the One Tap
// nonce, /s/:slug saves signer defaults, 2FA setup writes a secret, test mode
// signs in as the testing user), so they only load when actually clicked.
const unsafeToPrefetch = [
  /^\/sign_(in|up)(\/|$)/,
  /^\/s\//,
  /^\/mfa_setup(\/|$)/,
  /^\/testing_/,
  /^\/oauth\//
]

function beforePrefetchListener (event) {
  const { pathname } = new URL(event.target.href, window.location.href)

  if (unsafeToPrefetch.some((pattern) => pattern.test(pathname))) {
    event.preventDefault()
  }
}

function start () {
  document.addEventListener('turbo:before-prefetch', beforePrefetchListener)
}

export { start }
